export default __webpack_public_path__ + "static/media/image6.7d54ca6f.png";